module.exports = __webpack_public_path__ + "media/spotify-logo.fde8c5736034eeda7fa7dcc5cd2df8c4.svg";